module.exports = __webpack_public_path__ + "static/media/81.b957680e.jpg";